import { render } from "./LegalIcon.vue?vue&type=template&id=73929d06"
import script from "./LegalIcon.vue?vue&type=script&lang=js"
export * from "./LegalIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Icons/LegalIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73929d06"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73929d06', __exports__)) {
    api.reload('73929d06', __exports__)
  }
  
  module.hot.accept("./LegalIcon.vue?vue&type=template&id=73929d06", () => {
    api.rerender('73929d06', render)
  })

}


export default __exports__